export const SOLUTION_CATALOG_PATH = '/app/data/reseni/reseni/';
